export const HELLO_PATH = '/hello' as const;
export const CALENDAR_PATH = '/calendar' as const;
export const ROOT_PATH = `${HELLO_PATH}/:ownerType/:ownerId` as const;
export const ERROR_PATH = '/error' as const;
